import { HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_ALERT = new HttpContextToken<boolean>(() => false);
